import { Button, Tooltip } from "@mantine/core";
import { createStyles } from "@mantine/emotion";
import { IconPointFilled } from "@tabler/icons-react";
import type { ButtonCheckboxProps } from "./ButtonCheckbox";

const useStyles = createStyles(() => ({
  root: {
    "&&:focus, &&:focus-visible": {
      outline: "none",
      boxShadow: "none",
    },
  },
}));

const getBorder = (isActive: boolean, error?: string) => {
  if (isActive) {
    return "2px solid var(--mantine-color-brand-5)";
  }
  return error ? "1px solid var(--mantine-color-danger-5)" : "1px solid gray";
};

const JUSTIFY = {
  left: "flex-start",
  center: "center",
  right: "flex-end",
} as const;

export const ButtonCheckboxV2 = ({
  children,
  isActive,
  onClick,
  align,
  id,
  style,
  error,
  description,
  leftSection,
}: ButtonCheckboxProps) => {
  const { classes } = useStyles();

  return (
    <Tooltip label={description} position="bottom" disabled={!description}>
      <Button
        onClick={onClick}
        data-testid={`button-select-${id}`}
        aria-pressed={isActive}
        bg={isActive ? "var(--mantine-color-brand-1)" : "white"}
        c="brand"
        bdrs="xl"
        bd={getBorder(isActive, error)}
        justify={align && JUSTIFY[align]}
        leftSection={leftSection ?? (isActive && <IconPointFilled size={17} />)}
        classNames={{ root: classes.root }}
        style={style}
      >
        {children}
      </Button>
    </Tooltip>
  );
};
